/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import React, {useEffect} from 'react'
import {Link, useLocation} from 'react-router-dom'
import {MenuComponent} from '../../../assets/ts/components'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {Header} from './Header'
import {DefaultTitle} from './page-title/DefaultTitle'
import {Topbar} from './Topbar'
import {ToggleItem} from './ToggleItem'

export function HeaderWrapper() {
  const {pathname} = useLocation()
  const {config, classes, attributes} = useLayout()
  const {header, aside} = config

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [pathname])
  

  return (
    <div
      id='kt_header'
      className={clsx('header', classes.header.join(' '), 'align-items-stretch')}
      {...attributes.headerMenu}
    >
      



      <div
        className={clsx(
          classes.headerContainer.join(' '),
          'd-flex align-items-stretch justify-content-between'
        )}
      >
    
      <ul className="nav navbar-nav mr-auto float-left no-mobile">
            <li className="dropdown nav-item mega-dropdown">
              <a className="dropdown-toggle nav-link font-weight-bold" href="#" data-toggle="dropdown" ><span className="text-danger"> 
                TEST</span> | HIZLI PANEL </a>
                <ul className="mega-dropdown-menu dropdown-menu row p-1">
                    <li className="col-md-6 px-2 p-5">
                        <h6 className="font-weight-bold font-medium-2 ml-1">Hızlı Panel</h6>
                        <ul className="row mt-2">
                          <ToggleItem icon='la la-tag font-large-1 mr-0' to='taleplerim' title='Hızlı Talep' className='col-6 col-xl-3' linkClass='text-center mb-2 mb-xl-3' id=''/>
                          <ToggleItem icon='la la-shopping-cart font-large-1 mr-0' to='https://pilotgarageonline.com/magaza/panelden-magazaya-gecis' title='Mağazaya Git' className='col-6 col-xl-3' linkClass='text-center mb-2 mb-xl-3' id=''/>
                          <ToggleItem icon='la la-bank font-large-1 mr-0' to='bayi/bakiye-tanimla' title='Bakiye Yükle' className='col-6 col-xl-3' linkClass='text-center mb-2 mb-xl-3' id=''/>
                          <ToggleItem icon='la la-tag font-large-1 mr-0' to='bayi/bakiye-tanimla' title='Ön Muhasebe' className='col-6 col-xl-3' linkClass='text-center mb-2 mb-xl-3' id=''/>
                          <ToggleItem icon='la la-calendar font-large-1 mr-0' to='bayi-randevu-durumu-degistir' title='Randevulara Kapat' className='col-6 col-xl-3' linkClass='text-center mb-2 mb-xl-3' id=''/>
                          <ToggleItem icon='la la-info font-large-1 mr-0' to='bilgi-bankasi' title='Bilgi Bankası' className='col-6 col-xl-3' linkClass='text-center mb-2 mb-xl-3' id=''/>
                          <ToggleItem icon='la la-car font-large-1 mr-0' to='araba-kasalari' title='Araç Kasaları' className='col-6 col-xl-3' linkClass='text-center mb-2 mb-xl-3' id=''/>
                        </ul>
                    </li>
                    <li className="col-md-3 p-5">
                        <h6 className="font-weight-bold font-medium-2">Duyurular</h6>
                        <ul className="row mt-1 mt-xl-2">
                            <li className="col-12 col-xl-12 pl-0">
                              <ul className="mega-component-list results">
                                <ToggleItem icon='' to='https://pilotgarageonline.com/' title='BAKIM ve GÜNCELLEME ÇALIŞMASI' className='mega-component-item searchterm' linkClass='mb-1 mb-xl-2' id='14'/>
                                <ToggleItem icon='' to='https://pilotgarageonline.com/' title='2022 PİLOT GARAGE EKSPERTİZ PAKET FİYATLARI' className='mega-component-item searchterm' linkClass='mb-1 mb-xl-2' id='22'/>
                                <ToggleItem icon='' to='https://pilotgarageonline.com/' title='TRAMER SORGULAMA FİYAT DEĞİŞİKLİĞİ' className='mega-component-item searchterm' linkClass='mb-1 mb-xl-2' id='29'/>
                              </ul>
                            </li>
                        </ul>
                    </li>
                    <li className="col-md-3 p-5">
                        <h6 className="font-weight-bold font-medium-2">Belgeler</h6>
                        <ul className="row mt-1 mt-xl-2">
                            <li className="col-12 col-xl-12 pl-0">
                                <ul className="mega-component-list">    
                                  <ToggleItem icon='' to='arac_degerleme_hasar_etkisi.xlsx' title='ARAÇ DEĞERLEME HASAR ETKİSİ' className='mega-component-item' linkClass='mb-1 mb-xl-2' id=''/>
                                  <ToggleItem icon='' to='pilotgaranti.pdf' title='PİLOTGARAGE GARANTİ' className='mega-component-item' linkClass='mb-1 mb-xl-2' id=''/>
                                  <ToggleItem icon='' to='pg_sozlesme.docx' title='PİLOTGARAGE SÖZLEŞME' className='mega-component-item' linkClass='mb-1 mb-xl-2' id=''/>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>  
        </ul>





        {/* begin::Aside mobile toggle */}
        {aside.display && (
          <div className='d-flex align-items-center d-lg-none ms-n3 me-1' title='Show aside menu'>
            <div
              className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
              id='kt_aside_mobile_toggle'
            >
              <KTSVG path='/media/icons/duotune/abstract/abs015.svg' className='svg-icon-2x mt-1' />
            </div>
          </div>
        )}
        {/* end::Aside mobile toggle */}
        {/* begin::Logo */}
        {!aside.display && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
            <Link to='/dashboard' className='d-lg-none'>
              <img alt='Logo' src={toAbsoluteUrl('/media/logos/dark-logo.png')} className='h-30px' />
            </Link>
          </div>
        )}
        {/* end::Logo */}

        {aside.display && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
            <Link to='/' className='d-lg-none'>
              <img alt='Logo' src={toAbsoluteUrl('/media/logos/dark-logo.png')} className='h-30px' />
            </Link>
          </div>
        )}

        {/* begin::Wrapper */}
        <div className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'>
          {/* begin::Navbar */}
          {header.left === 'menu' && (
            <div className='d-flex align-items-stretch' id='kt_header_nav'>
              <Header />
            </div>
          )}

          {header.left === 'page-title' && (
            <div className='d-flex align-items-center' id='kt_header_nav'>
              <DefaultTitle />
            </div>
          )}

          <div className='d-flex align-items-stretch flex-shrink-0'>
            <Topbar />
          </div>
        </div>
        {/* end::Wrapper */}
      </div>
    </div>
  )
}
